module.exports = __webpack_public_path__ + "img/punctuality.23874239.png";